import { httpsCallable } from 'firebase/functions';
import { getFirebaseFunctions } from '../firebase/index';
import type { BillingCycle, SubscriptionPlan } from '../types';

export interface CheckoutSessionPayload {
  workspaceId: string;
  plan: SubscriptionPlan;
  billingCycle: BillingCycle;
  returnUrl?: string;
  cancelUrl?: string;
}

export interface CheckoutSessionResponse {
  checkoutUrl: string;
}

export const beginWorkspaceCheckout = async (
  params: CheckoutSessionPayload
): Promise<string> => {
  const functions = await getFirebaseFunctions();
  const callable = httpsCallable<CheckoutSessionPayload, CheckoutSessionResponse>(
    functions,
    'billingStartWorkspaceCheckout'
  );
  const response = await callable(params);
  if (!response.data?.checkoutUrl) {
    throw new Error('missing-checkout-url');
  }
  return response.data.checkoutUrl;
};

export const openBillingPortal = async (
  workspaceId: string,
  returnUrl: string
): Promise<string> => {
  const functions = await getFirebaseFunctions();
  const callable = httpsCallable<{ workspaceId: string; returnUrl: string }, { portalUrl: string }>(
    functions,
    'billingOpenPortal'
  );
  const response = await callable({ workspaceId, returnUrl });
  if (!response.data?.portalUrl) {
    throw new Error('missing-portal-url');
  }
  return response.data.portalUrl;
};
